var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"c-saving"},[_c('base-icon',{staticClass:"mr-2 icon",attrs:{"width":"24","height":"24","name":"painel/cloud"}}),_vm._v(" Salvando ")],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }